/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SendOTPDTO
 */
export interface SendOTPDTO {
	/**
	 *
	 * @type {string}
	 * @memberof SendOTPDTO
	 */
	email?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof SendOTPDTO
	 */
	otp?: string | null;
}

export function SendOTPDTOFromJSON(json: any): SendOTPDTO {
	return SendOTPDTOFromJSONTyped(json, false);
}

export function SendOTPDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): SendOTPDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		email: !exists(json, "email") ? undefined : json["email"],
		otp: !exists(json, "otp") ? undefined : json["otp"],
	};
}

export function SendOTPDTOToJSON(value?: SendOTPDTO | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		email: value.email,
		otp: value.otp,
	};
}
